  <template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <p class="text-regular text-center mb-1">
      Selecione o tipo de banner e as categorias
    </p>
    <b-form-group>
      <b-row>
        <b-form-group
          class="col-12 col-lg"
          label="Tipo de Banner"
          label-cols="12"
          label-class="col-lg-auto"
        >
          <SearchBox
            :dataObject="bannerTypes"
            searchCritery="name"
            displayValue="name"
            idToSelectOptions="value"
            :isInvalid="!!errors.bannerType"
            placeholder="Selecione o tipo de banner"
            v-model="options.bannerType"
            :radio="true"
            :hideDeselect="true"
            :hideSearch="true"
            @change="track(options.bannerType, 'Selecionou tipo do banner')"
          />
          <b-form-invalid-feedback
            v-if="errors.bannerType"
            class="d-block"
            v-html="errors.bannerType"
          />
        </b-form-group>
        <b-form-group
          class="col-12 col-lg"
          label="Categorias"
          label-cols="12"
          label-class="col-lg-auto"
        >
          <SearchBox
            :dataObject="activeCategories"
            searchCritery="name"
            displayValue="name"
            idToSelectOptions="id"
            :isInvalid="!!errors.category"
            :searchNameAll="'Todas as categorias'"
            placeholder="Selecione uma ou mais categorias"
            v-model="options.category"
            :radio="isBannerStatic()"
            @change="track(options.category, 'Selecionou categoria')"
          />
          <b-form-invalid-feedback
            v-if="errors.category"
            class="d-block"
            v-html="errors.category"
          />
        </b-form-group>
      </b-row>
      <b-row
        v-if="showCompliance"
        class="align-content-center justify-content-center"
      >
        <b-form-group
          class="text-center mb-1 col-8 col-lg-12 banner-form__rules-field"
        >
          <ComplianceField
            v-model="options.acceptedRules"
            :isInvalid="!!errors.acceptedRules"
            :rulesModalTrackLabel="`regras de divulgação_${advertiser.name}`"
          >
            <template
              v-slot:rules="{ closeComplianceModal }"
              v-bind:showAllRules="showAllRules"
            >
              <p>
                Antes de gerar o link, atente-se às principais regras de
                divulgação do programa:
              </p>
              <ul>
                <li>
                  O afiliado não pode se passar por representante comercial do
                  PagBank ou funcionário UOL/PagBank. As menções aos
                  produtos e marcas do grupo UOL devem ser feitas em terceira
                  pessoa;
                </li>
                <li>
                  Não é permitido nas URLs e títulos de seus sites, blogs ou
                  páginas de redes sociais os nomes de produtos e marcas do
                  grupo UOL/PagBank;
                </li>
                <li>
                  Não é permitida a utilização de logotipos do grupo UOL e/ou
                  PagBank em sua divulgação, bem como a imagem dos atores e
                  cantores que estrelam peças publicitárias da marca;
                </li>
                <li>
                  É proibido plagiar conteúdo de páginas oficiais do PagBank
                  ou de outros afiliados, bem como divulgar seus links em
                  publicações que não são suas.
                </li>
              </ul>
              <p>
                Caso as regras não sejam respeitadas, sua conta poderá ser
                cancelada sem aviso prévio conforme rege o nosso contrato.
              </p>
              <p>
                <span>Consulte todas as regras </span>
                <b-button
                  variant="link"
                  class="text-decoration-none link align-baseline p-0"
                  @click="
                    closeComplianceModal();
                    showAllRules();
                  "
                >
                  aqui
                </b-button>
                <span>.</span>
              </p>
            </template>
          </ComplianceField>
          <b-form-invalid-feedback
            v-if="errors.acceptedRules"
            class="d-block text-center mt-0"
            v-html="errors.acceptedRules"
          ></b-form-invalid-feedback>
        </b-form-group>
      </b-row>
    </b-form-group>

    <b-row v-if="visibleOptions">
      <b-form-group class="col-12 col-lg-4" label="Medida">
        <SearchBox
          :dataObject="banners"
          searchCritery="dimensions"
          displayValue="dimensions"
          idToSelectOptions="idt_aff_campaign_creative"
          :isInvalid="!!errors.dimension"
          placeholder="Selecione uma medida"
          v-model="options.dimension"
          :radio="true"
          @change="track(options.dimension, 'Selecionou formato do banner')"
        >
          <template v-slot:customView="{ rows, pickFunc }">
            <b-table
              hover
              small
              :items="rows"
              :fields="visibleColumns"
              primary-key="em_id"
              table-class="text-dark"
              thead-class="table-small-title"
              tbody-tr-class="pointer"
              @row-clicked="pickFunc($event)"
            >
              <template slot="[em_html_code]" slot-scope="data">
                <div class="text-center">
                  <b-button
                    variant="link"
                    size="sm"
                    class="align-baseline"
                    @click="
                      showPreview(data.item);
                      track(options.dimension, 'Viu preview do banner');
                    "
                  >
                    <b-img
                      fluid
                      src="@/assets/preview.svg"
                      alt="Preview"
                    ></b-img>
                  </b-button>
                </div>
              </template>
            </b-table>
          </template>
        </SearchBox>
        <b-form-invalid-feedback
          v-if="errors.dimension"
          class="d-block"
          v-html="errors.dimension"
        />
      </b-form-group>
      <b-form-group class="col-12 col-lg-4" label="Site">
        <SearchBoxSites
          v-model="options.site"
          @change="track(options.site, 'Selecionou site')"
        />
        <b-form-invalid-feedback
          v-if="errors.site"
          class="d-block"
          v-html="errors.site"
        />
      </b-form-group>

      <b-form-group class="col-12 col-lg-4">
        <template v-slot:label>
          <span>Identificador </span>
          <span class="sub-label"> (Opcional) </span>
          <b-img
            fluid
            src="@/assets/images/icon_info.svg"
            alt="Info"
            v-b-popover.hover.top="{
              customClass: 'custom-info-popover',
              content:
                'Nome dado para marcar uma peça gerada de acordo com a sua preferência.',
            }"
          >
          </b-img>
        </template>
        <SearchBox
          :dataObject="affiliateLabels"
          searchCritery="desLabel"
          displayValue="desLabel"
          idToSelectOptions="idtUserSupplierLabel"
          placeholder="Selecione um identificador"
          v-model="options.label"
          :radio="true"
          class="label-sb"
          :class="!affiliateInfo ? 'loading-placeholder' : ''"
          @change="track(options.label, 'Selecionou identificador')"
        />
        <template v-slot:description>
          <b-button
            variant="link"
            size="sm"
            class="text-decoration-none info-identifier pl-0"
            @click.stop="
              toggleControls();
              track('toggleControls', 'Abriu seletor de identificadores');
              track(`configurar identificador_${advertiser.name}`);
            "
          >
            Configurar identificador
          </b-button>
        </template>
      </b-form-group>
    </b-row>

    <b-modal
      id="preview-modal"
      header-class="close-modal-header"
      sz="lg"
      dialog-class="banner-preview-dialog"
      content-class="banner-preview-content"
      body-class="d-flex embed-responsive-item justify-content-center align-content-center"
      footer-class="border-0 d-flex justify-content-center pt-1"
      centered
    >
      <Loader
        v-show="!loadedAffiliateInfo && !currentPreview"
        :width="previewWidth"
        :height="previewHeight"
      >
      </Loader>
      <iframe
        v-if="loadedAffiliateInfo || currentPreview"
        class="d-flex embed-responsive-item"
        :src="currentPreview"
        :width="previewWidth"
        :height="previewHeight"
        frameborder="0"
        allowfullscreen
      ></iframe>
      <template slot="modal-footer" slot-scope="{ close }">
        <b-button
          variant="orange"
          class="main-action-button close-preview"
          @click="close()"
        >
          Fechar
        </b-button>
      </template>
    </b-modal>

    <b-row align-h="around" v-if="visibleScript" class="text-dark">
      <b-col sm="12" md="10" class="text-center pr-md-0">
        <b-form-group class="position-relative mb-0">
          <b-form-textarea
            id="code-field"
            class="text-dark fs-14 code-scroll"
            no-resize
            :readonly="true"
            v-model="bannerScript"
            rows="5"
            max-rows="5"
            ref="scriptField"
          >
          </b-form-textarea>
          <div
            class="
              copy-overlay
              d-flex
              flex-column
              align-items-center
              justify-content-center
              text-center
              code-overlay
            "
            :class="[scriptCopied ? 'visible' : 'invisible']"
          >
            <b-img
              class="copy-img"
              src="@/assets/copy_check.svg"
              alt="Script copiado"
            ></b-img>
            <span class="copy-msg ml-1">Script copiado com sucesso</span>
          </div>
        </b-form-group>
      </b-col>
      <b-col
        sm="12"
        md="2"
        class="text-right d-flex flex-column pl-md-1 btn-copy-code"
      >
        <b-button
          variant="grey-shadowed flex-grow-1 fs-13 btn-res"
          @click="
            copyScript();
            track('Copiou o script');
            track(
              `copiar script_banner estático ou banner rotativo_${advertiser.name}`
            );
          "
        >
          Copiar script
        </b-button>
      </b-col>

      <b-col v-if="affiliateHasPostback">
        <div class="d-flex align-items-center postback-warn mt-1">
          <b-img
            class="pr-2"
            src="@/assets/warning_icon.png"
            alt="Atenção"
          ></b-img>
          <span>Não se esqueça de substituir os parâmetros do script</span>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="!visibleScript" class="d-flex justify-content-center mt-4">
      <b-button
        id="continueButton"
        type="submit"
        variant="orange"
        class="main-action-button"
        @click="continueClick"
      >
        Continuar
      </b-button>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HistoryApi from '@/services/history';
import SearchBox from '@/components/SearchBox';
import {
  generatePostbackParameters,
  b64EncodeUnicode,
} from '@/utils/campaignUtils';
import SearchBoxSites from '@/components/SearchBoxSites';
import Loader from '@/components/Loader';
import ComplianceField from './ComplianceField';
import { isAdvertiserCustomRules } from '@/utils/advertiserUtils';

const DEFAULT_UOL_CLIQUES_COLOR = ';descrColor=000000;titleColor=000000;urlColor=A6A6A6;'
  + 'borderColor=FFFFFF;bgColor=FFFFFF;altColor=FFFFFF';
const UOL_CLIQUES_ID = 1;


export default {
  name: 'BannerFormCard',
  components: {
    SearchBox,
    ComplianceField,
    SearchBoxSites,
    Loader,
  },
  async created() {
    const { pageAdvertiser } = this;
    this.advertiser = pageAdvertiser;
    this.rules = this.advertiser.rules;
    this.categories = this.advertiser.campaigns;
  },
  props: {
    presetLabel: Object,
  },
  data() {
    return {
      visibleColumns: [
        {
          key: 'dimensions',
          label: 'Medida',
          thClass: 'no-border-bottom',
          tdClass: 'light-border-bottom',
        },
        {
          key: 'em_html_code',
          label: 'Preview',
          thClass: 'no-border-bottom',
          tdClass: 'light-border-bottom',
        },
      ],
      visibleOptions: false,
      visibleScript: false,
      bannerScript: '',
      scriptCopied: false,
      currentPreview: null,
      previewWidth: null,
      previewHeight: null,
      banners: [],
      rules: '',
      bannerTypes: [
        { value: 'static', name: 'Estático' },
        { value: 'rotating', name: 'Rotativo' },
      ],
      categories: [],
      advertiser: {},
      options: {
        acceptedRules: false,
        bannerType: ['static'],
        category: '',
        dimension: '',
        site: '',
        label: '',
      },
      errors: {
        acceptedRules: null,
        bannerType: null,
        category: null,
        dimension: null,
        site: null,
      },
      inputsErrorMessages: {
        acceptedRules:
          'Por favor leia e aceite as <strong>Regras de Divulgação</strong>',
        bannerType: 'Selecione o <strong>tipo do banner</strong>',
        category: 'Selecione a <strong>categoria</strong>',
        dimension: 'Selecione a <strong>medida</strong>',
        site: 'Selecione o <strong>site</strong>',
      },
      firstStepInputs: ['acceptedRules', 'bannerType', 'category'],
      allNeededInputs: [
        'acceptedRules',
        'bannerType',
        'category',
        'dimension',
        'site',
      ],
      postbackOptional: ['site'],
    };
  },
  methods: {
    continueClick() {
      if (this.visibleOptions && this.validateForm(this.allNeededInputs)) {
        const caf = this.codDisplaySupplier;
        this.bannerScript = this.generateScript(this.selectedCreative, caf);
        this.visibleScript = true;
        this.saveFormatHistory();
      } else if (this.validateForm(this.firstStepInputs)) {
        this.visibleOptions = true;
      }
    },
    copyScript() {
      this.$refs.scriptField.select();
      window.document.execCommand('copy');
      this.$refs.scriptField.setSelectionRange(0, 0);
      this.$refs.scriptField.blur();
      this.scriptCopied = true;
      this.clearCopyDivs();
    },
    clearCopyDivs() {
      setTimeout(() => {
        this.scriptCopied = false;
      }, 5000);
    },
    validateForm(neededInputs) {
      let valid = true;
      let inputs = [...neededInputs];
      if (!this.showCompliance) {
        inputs = inputs.filter(input => input !== 'acceptedRules');
      }
      inputs.forEach((input) => {
        const isObject = typeof this.options[input] === 'object';
        if (
          ((!isObject && !this.options[input])
            || (isObject && !this.options[input].length))
          && !(this.affiliateHasPostback && this.postbackOptional.includes[input])
        ) {
          this.errors[input] = this.inputsErrorMessages[input];
          valid = false;
        }
      });
      return valid;
    },
    async getResource(url) {
      const response = await fetch(url);
      const data = await response.body.getReader().read();
      return new TextDecoder('utf-8').decode(data.value);
    },
    async showPreview(banner) {
      if (this.advertiser.id === UOL_CLIQUES_ID) {
        const self = this;

        (function waitForAffiliateInfo() {
          setTimeout(() => {
            if (!self.loadedAffiliateInfo) {
              waitForAffiliateInfo();
            } else {
              self.currentPreview = self.buildSrcForPreview(
                banner,
                self.codDisplaySupplier,
              );
            }
          }, 1000);
        }());
      } else {
        this.currentPreview = this.getRandomCreativeId(banner.creatives);
      }
      const width = Number(/(\d*)/.exec(banner.dimensions)[1]);
      const height = Number(/x(\d*)/.exec(banner.dimensions)[1]);
      const scrollPadding = 15;

      this.previewWidth = width;
      this.previewHeight = height + scrollPadding;
      this.$bvModal.show('preview-modal');
    },
    generateScriptParams(banner, caf) {
      const ord = Date.now();
      const categoryName = this.selectedCategoryName
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      let creative = `AFILIADOS_${this.advertiser.name}_${categoryName}_${banner.dimensions}`;
      creative = encodeURIComponent(
        b64EncodeUnicode(creative.replace(/ /g, '_')),
      );
      const params = {
        dc: banner.creative_id,
        ord,
        idt_product: this.advertiser.id,
        aff_source: caf,
      };

      if (this.advertiser.id === UOL_CLIQUES_ID) {
        params.coddisplaysupplier = `${caf}${DEFAULT_UOL_CLIQUES_COLOR}`;
        params.deslabel = this.options.label;
      } else {
        params.cpg = encodeURIComponent(btoa(this.options.site));
        params.idt_label = this.options.label;
        params.idt_category = this.selectedCategoriesFormats.join(',');
        params.idt_banner = banner.idt_aff_campaign_creative;
        params.idt_url = this.options.site;
        params.caf = caf;
        params.creative = creative;
      }
      if (this.affiliateHasPostback) {
        params.parameters = generatePostbackParameters(
          this.advertiser.id,
          this.affiliateInfo.postbackConfig,
        ).replace(/;/g, encodeURIComponent(';'));
        params.cpg = caf ? encodeURIComponent(caf) : null;
      }
      return params;
    },
    generateAffiliatedScriptParams(banner, caf) {
      const categoryName = this.selectedCategoryName
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      let creative = `${categoryName}_${banner.dimensions}`;
      creative = encodeURIComponent(
        b64EncodeUnicode(creative.replace(/ /g, '_')),
      );
      const params = {
        source: this.advertiser.id,
        caf,
      };

      if (this.advertiser.id === UOL_CLIQUES_ID) {
        params.coddisplaysupplier = `${caf}${DEFAULT_UOL_CLIQUES_COLOR}`;
        params.deslabel = this.options.label;
      } else {
        params.cpg = encodeURIComponent(btoa(this.options.site));
        params.idtLabel = this.options.label;
        params.idtCreatives = this.selectedCategoriesFormats.join(',');
        params.idtBanner = banner.idt_aff_campaign_creative;
        params.idtUrl = this.options.site;
        params.caf = caf;
        params.creative = creative;
      }
      if (this.affiliateHasPostback) {
        params.parameters = generatePostbackParameters(
          this.advertiser.id,
          this.affiliateInfo.postbackConfig,
        ).replace(/;/g, encodeURIComponent(';'));
        params.cpg = caf ? encodeURIComponent(caf) : null;
      }
      return params;
    },
    buildSrcFromParams(params) {
      const creativeJsFile = process.env.CREATIVE_JS || 'affiliatedAdCreative.js';
      let src = `https://conteudo.jsuol.com.br/p/afiliados/adrequisitor/${creativeJsFile}?`;
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          src += `${key}=${params[key]}&`;
        }
      });
      src += 'click=';
      return src;
    },
    buildSrcAffiliatedFromParams(banner, caf) {
      const params = this.generateAffiliatedScriptParams(banner, caf);
      const creativeJsFile = process.env.CREATIVE_JS || 'affiliatedAdCreative.js';
      let src = `https://conteudo.jsuol.com.br/p/afiliados/adrequisitor/${creativeJsFile}?`;
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          src += `${key}=${params[key]}&`;
        }
      });
      src += 'click=';
      return src;
    },
    buildSrcForPreview(banner, caf) {
      const params = this.generateScriptParams(banner, caf);
      if (this.advertiser.id === UOL_CLIQUES_ID) {
        const urls = this.approvedUrls;
        params.defaultAffUrl = urls[Object.keys(urls)[0]].desUrl;
        params.srctype = 'ifrm';
      }
      return this.buildSrcFromParams(params);
    },
    generateScript(banner, caf) {
      let src = null;
      src = this.buildSrcAffiliatedFromParams(banner, caf);
      // eslint-disable-next-line
      return `<span><script id="affiliatedScript" language="JavaScript1.1" src="${src}"><\/script><\/span>`;
    },
    clearAfterBannerType() {
      this.options.category = '';
    },
    clearAfterCategory() {
      this.clearAfterAcceptedRules();
    },
    clearAfterAcceptedRules() {
      this.banners = [];
      this.options.dimension = '';
      if (
        !this.options.category.length
        || (this.showCompliance && !this.options.acceptedRules)
      ) {
        this.visibleOptions = false;
      }
    },
    clearAfterDimension() {
      this.visibleScript = false;
      this.bannerScript = '';
    },
    isBannerStatic() {
      if (this.options.bannerType.length === 1) {
        return this.options.bannerType[0] === 'static';
      }

      return this.options.bannerType === 'static';
    },
    showAllRules() {
      this.$emit('showAllRules');
    },
    async saveFormatHistory() {
      const payload = {
        idtPerson: this.affiliateInfo.idtPerson,
        idtProductSource: this.advertiser.id,
        idtFormat: this.options.dimension[0],
        format: `Banner ${this.bannerTypes
          .filter(type => type.value === this.options.bannerType[0])
          .map(type => type.name)[0]
          .toLowerCase()}`,
        category: this.getCategoryDescription(),
        description: this.banners
          .filter(
            banner => banner.idt_aff_campaign_creative === this.options.dimension[0],
          )
          .map(banner => banner.dimensions)[0],
        content: this.bannerScript,
        label: this.affiliateLabels
          .filter(
            label => label.idtUserSupplierLabel === this.options.label[0],
          )
          .map(label => label.desLabel)[0],
        site: this.approvedUrlsByIdt
          .filter(site => site.idtUserSupplierUrl === this.options.site[0])
          .map(site => site.desUrl)[0],
      };
      await HistoryApi.insertHistory(payload);
    },
    getCategoryDescription() {
      let category = [];

      if (
        this.options.category.length === 1
        || this.options.category.length < this.activeCategories.length
      ) {
        for (let i = 0; i < this.options.category.length; i += 1) {
          const found = this.activeCategories.find(
            element => element.id === this.options.category[i],
          );
          if (found !== null && found !== undefined) {
            category.push(found.name);
          }
        }
      } else {
        category = ['Todas as categorias'];
      }

      return category.length === 1 ? category[0] : category.join();
    },
    groupBy(array, key) {
      return array.reduce((acc, item) => {
        if (!acc[item[key]]) acc[item[key]] = [];
        acc[item[key]].push(item);
        return acc;
      }, []);
    },
    groupByBanners(banners) {
      const bannersResult = [];
      const groupedBanners = this.groupBy(banners, 'dimensions');
      const keys = Object.keys(groupedBanners);
      const values = Object.values(groupedBanners);
      for (let i = 0; i < keys.length; i += 1) {
        const banner = {
          creative_id: values[i][0].creative_id,
          dimensions: values[i][0].dimensions,
          format: values[i][0].format,
          idt_aff_campaign_creative: values[i][0].idt_aff_campaign_creative,
          creatives: values[i],
        };
        bannersResult.push(banner);
      }
      return bannersResult;
    },
    getRandomCreativeId(creatives) {
      if (creatives && creatives.length > 0) {
        const domain = this.getUrlCloudfrontCreative.domainCreatives;
        // eslint-disable-next-line camelcase
        const { idt_aff_campaign_creative_img } = creatives[this.getRandomIntInclusive(0, creatives.length - 1)];
        // eslint-disable-next-line camelcase
        return `${domain}/${idt_aff_campaign_creative_img}.gif`;
      }
      return '';
    },
    getRandomIntInclusive(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
  },
  computed: {
    ...mapGetters([
      'pageAdvertiser',
      'affiliateLabels',
      'approvedUrls',
      'affiliateInfo',
      'approvedUrlsByIdt',
      'getUrlCloudfrontCreative',
    ]),
    selectedCreative() {
      if (!this.options.dimension) return null;

      return this.banners.find(
        banner => banner.idt_aff_campaign_creative === this.options.dimension[0],
      );
    },
    selectedCategory() {
      if (!this.options.category.length) return null;
      return this.categories.find(
        category => category.id === this.options.category[0],
      );
    },
    selectedCategoryName() {
      if (this.selectedCategory) return this.selectedCategory.name;
      return '';
    },
    activeCategories() {
      if (!this.categories) return [];
      return this.categories.filter(category => category.active);
    },
    affiliateHasPostback() {
      try {
        return Object.keys(this.affiliateInfo.postbackConfig).length > 0;
      } catch {
        return false;
      }
    },
    codDisplaySupplier() {
      return this.affiliateInfo.codDisplaySupplier;
    },
    showCompliance() {
      if (!this.advertiser) return false;
      return isAdvertiserCustomRules(this.advertiser.id);
    },
    selectedCategoriesFormats() {
      const { category } = this.options;
      if (!category.length) return [];
      const idtsCreatives = this.categories
        .filter(({ id }) => category.includes(id))
        .map(({ formats }) => formats.find(({ id }) => id === 'banners'))
        .filter(el => el !== null && el !== undefined)
        .map(cr => cr.creatives)
        .flatMap(subArray => subArray.filter(obj => obj.format === this.selectedCreative.format)
          .map(obj => obj.idt_aff_campaign_creative_img));

      idtsCreatives.push(`${this.selectedCreative.idt_aff_campaign_creative}_fallback`);
      return idtsCreatives;
    },
    loadedAffiliateInfo() {
      return this.affiliateInfo !== null;
    },
  },
  watch: {
    'options.acceptedRules': {
      handler() {
        if (this.options.acceptedRules) {
          this.errors.acceptedRules = null;
        } else {
          this.clearAfterAcceptedRules();
        }
      },
    },
    'options.bannerType': {
      handler() {
        this.clearAfterBannerType();
      },
    },
    'options.category': {
      handler() {
        this.errors.category = null;
        this.clearAfterCategory();
        if (this.selectedCategory) {
          this.banners = this.groupByBanners(
            this.selectedCategory.formats.find(
              format => format.id === 'banners',
            ).creatives,
          );
        }
      },
    },
    'options.dimension': {
      handler() {
        this.errors.dimension = null;
        this.clearAfterDimension();
      },
    },
    'options.site': {
      handler() {
        this.errors.site = null;
        this.clearAfterDimension();
      },
    },
    presetLabel: {
      immediate: true,
      handler(label) {
        if (label) {
          this.options.label = [label.idtUserSupplierLabel];
        }
      },
    },
    'options.label': {
      handler(selectedLabels) {
        const selectedLabel = this.affiliateLabels.find(label => selectedLabels.includes(label.idtUserSupplierLabel));
        this.$emit('labelUpdated', selectedLabel);
        this.clearAfterDimension();
      },
    },
  },
  inject: ['toggleControls'],
};
</script>

<style lang="scss" scoped>
.show-tooltip {
  border: 2px solid $text-light;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.4em;
  font-size: 0.7em;
  display: inline-block;
  border-radius: 50%;
}

.link-copied {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.fa-check-circle {
  color: $chateau-green;
}

strong {
  font-size: $font-size-xs-small;
}

.postback-warn {
  font-size: $font-size-lg-small;
  line-height: normal;
}

.modal-header {
  border-bottom: 0 none;
}

.modal-footer {
  border-top: 0 none;
}

a:not([href]) {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}

a:not([href]):hover {
  color: #0056b3;
  text-decoration: underline;
  cursor: pointer;
}

.modal-lg {
  max-width: 90% !important;
}

.sub-label {
  font-size: 12px;
  color: $dove-gray-2;
}

.fs-14 {
  font-size: 14px;
}

.link {
  padding: 0;
  border: 0;
  color: $denim;
}
.rules-cb {
  padding-left: 2rem;
}

.copy-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: $alabaster;
  opacity: 0.96;
  .copy-img {
    width: 27px;
  }
  .copy-msg {
    font-weight: bold;
    color: $jade;
  }
}
</style>
